import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconInfo from '@/icons/Info.svg';
import { computeDuplicateDefectNumber, useGetDefectName } from '@/models/defectType';
import { ArticleWithRelations } from '@/models/request';

export const DefectsNotToBeRepaired = ({ article }: { article: ArticleWithRelations }) => {
  const getDefectName = useGetDefectName();

  if (article.snapshot.serviceChoice !== 'care-repair') {
    return null;
  }

  const defectsNotToBeRepaired = article.snapshot.articleDefects.filter(
    (defect) => !defect.toBeRepaired && !defect.articleActionToArticleDefects.length
  );

  if (!defectsNotToBeRepaired.length) {
    return null;
  }

  const defects = defectsNotToBeRepaired
    .map((defect) => {
      const name = getDefectName(defect);
      const duplicateNumber = computeDuplicateDefectNumber(defect, article.snapshot.articleDefects);
      const duplicateNumberLabel =
        article.snapshot.articleDefects.length > 1 && duplicateNumber ? ` #${duplicateNumber}` : '';
      const context = defect.context ? `"${defect.context}"` : '';

      return `${name} ${duplicateNumberLabel} ${context}`.trim();
    })
    .join(' • ');

  return (
    <Stack row gap="0.25rem" flexWrap="nowrap">
      <IconInfo className="color-tertiary-700" />
      <Paragraph size="200">
        <Trans id="client.article.defects-not-to-be-repaired">
          Noted defects with no required services: {defects}
        </Trans>
      </Paragraph>
    </Stack>
  );
};
